export default {
    default: {
        fetchModelsPeriod: 30000, // définit le temps en ms entre chaque fetch
    },
    listModels: {
        channels:{
            url:'channel/',
            fetch: true,
            filter:{
                archived: false,
            }
        },
        users:{
            url:'user/',
            fetch: false,
        },
        assets:{
            url: 'asset/',
            fetch: false,
        }
    },
};



// WEBPACK FOOTER //
// ./src/store/meta.js